/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Row,
  Col,
  Form,
  Upload,
  Button,
  message,
  Image,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import MenuService from "../../../services/MenuService";
import CustomizationService from "../../../services/CustomizationService";
import StoryTemplate from "./StoryTemplate";
import CustomInput from "../../../components/CustomInput";
import CustomTextArea from "../../../components/CustomTextArea";
import CustomSelect from "../../../components/CustomSelect";

import _ from "lodash";

import {
  checkResolution,
  convertFormDataToObject,
  dummyRequest,
  transformImageFileToUrlObject,
} from "../../../utils";
import TestimonialService from "../../../services/TestimonialService";

const { Dragger } = Upload;
const { Title } = Typography;

export default function Story({ isPreview }) {
  const [customizationData, setCustomizationData] = useState({});
  const [menus, setMenus] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [formFieldsdata, setFormFieldsData] = useState();
  const [selectedMenuID, setSelectedMenu] = useState();

  const [form] = Form.useForm();

  const menuID = Form.useWatch("our_story_featured_menu", form);

  let restaurantID = localStorage.getItem("restaurantId");

  useEffect(() => {
    getMenus();
    fetchCustomizationData();
  }, []);

  useEffect(() => {
    if (menuID) {
      getMenuItems();
    }
  }, [menuID, menus]);

  const getMenus = async () => {
    const data = await MenuService.getMenus(restaurantID);
    setMenus(
      data.menus?.map((item) => ({
        value: Number(item?.id),
        label: item?.name,
        ...item,
      }))
    );
  };

  const getMenuItems = async () => {
    const menuItems = menus.filter((item) => item.id === menuID)[0]?.menu_items;
    const filteredMenuItems = _.filter(menuItems, { is_active: true });
    setMenuItems(filteredMenuItems);
  };

  const removeNullValues = (obj) => {
    // Create a new object without null values
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== null)
    );
  };

  const saveCustomizationData = async () => {
    setIsSaving(true);
    try {
      const cleanedPayload = removeNullValues(formFieldsdata);
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.banner_heading;
      delete cleanedPayload?.catering_event_types;
      delete cleanedPayload?.certifications;
      delete cleanedPayload?.created_at;
      delete cleanedPayload?.id;
      delete cleanedPayload?.landing_page_button_title;
      delete cleanedPayload?.our_story_description;
      delete cleanedPayload?.restaurant_id;
      delete cleanedPayload?.restaurant_special_tagline;
      delete cleanedPayload?.testimonials;
      delete cleanedPayload?.theme;
      delete cleanedPayload?.updated_at;
      delete cleanedPayload?.updated_by;
      const updatedData = {
        ...cleanedPayload,
        our_story_featured_menu: Number(
          cleanedPayload?.our_story_featured_menu
        ),
      };
      const saveBuilder = await CustomizationService.saveCustomization(
        restaurantID,
        updatedData
      );
      if (saveBuilder) message.success("Update Successful");
    } catch (error) {
      setIsSaving(false);
      message.error("Update Failed");
    }
  };

  const fetchCustomizationData = async () => {
    const data = await CustomizationService.getCustomizations(restaurantID);
    data.our_story_featured_menu = Number(data?.our_story_featured_menu);
    form.setFieldsValue(data);
    setFormFieldsData(data);
    setCustomizationData(data);
  };

  const handleImageChange = async (info, type) => {
    if (info.file.status === "done") {
      const isResolutionValid = await checkResolution(info.file.originFileObj);
      if (!isResolutionValid) {
        message.error("Image resolution must be greater than 1920 X 1080");
        return;
      }

      const formData = new FormData();
      formData.append("file", info.file.originFileObj);
      const data = await TestimonialService.uploadPhoto(formData);
      if (data) {
        form.setFieldsValue({ [type]: data.url });
        setFormFieldsData(form.getFieldsValue());
      }
    }
  };

  const gandleFormValueChanges = (changedValue, allValues) => {
    setFormFieldsData(form.getFieldsValue());
  };

  useEffect(() => {
    if (!menuID || menus.length === 0) return;
    setSelectedMenu(Number(form.getFieldsValue()?.our_story_featured_menu));
    setMenuItems(
      menus.find(
        (item) => item.id == form.getFieldsValue()?.our_story_featured_menu
      )?.menu_items
    );
    const validMenuItemIds = menus.find(
      (item) => item.id == form.getFieldsValue()?.our_story_featured_menu
    )?.menu_items;

    const updated = form
      .getFieldsValue()
      ?.our_story_featured_menu_ids?.filter((id) =>
        validMenuItemIds?.some((item) => item.id === id)
      );
    
    form.setFieldsValue({ our_story_featured_menu_ids: updated || [] });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ menus,menuID]);

  return (
    <Row
      style={{
        background: "#FFFFFF",
        padding: 16,
        borderRadius: 5,
      }}
    >
      <Col xs={24} lg={12}>
      <Form
        form={form}
        name="story"
        onFieldsChange={(_, allFields) => {
          setCustomizationData(convertFormDataToObject(allFields));
        }}
        onValuesChange={gandleFormValueChanges}
        scrollToFirstError
      >
        <div className="theme-container">
          <Row>
            <Col span={24}>
              <Title level={5} className="theme-red mb-1">
                Banner
              </Title>

              <Form.Item name="our_story_banner_heading">
                <CustomInput label="Heading" placeholder="Enter heading here" />
              </Form.Item>
              <div className="mb-1">Upload Discount Banner Image</div>

              <Form.Item name="our_story_banner_image_url">
                <Dragger
                  multiple={false}
                  customRequest={dummyRequest}
                  onChange={(info) =>
                    handleImageChange(info, "our_story_banner_image_url")
                  }
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Upload Discount Banner Image
                  </p>
                </Dragger>
              </Form.Item>
              {typeof customizationData.our_story_banner_image_url ===
                "string" && (
                <Image
                  width={200}
                  src={customizationData.our_story_banner_image_url}
                />
              )}
              <Divider />
              <Title level={5} className="theme-red mb-1">
                Story
              </Title>
              <Form.Item name="our_story_heading">
                <CustomInput
                  label="Heading"
                  placeholder="Enter story heading here"
                />
              </Form.Item>
              <Form.Item name="our_story_description">
                <CustomTextArea
                  label="Description"
                  placeholder="Enter story description here"
                />
              </Form.Item>
              <div className="mb-1">Upload Image</div>
              <Form.Item name="our_story_image_url">
                <Dragger
                  multiple={false}
                  customRequest={dummyRequest}
                  onChange={(info) =>
                    handleImageChange(info, "our_story_image_url")
                  }
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag image file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {/* {typeof customizationData.our_story_image_url === "string" && (
                <Image
                  width={200}
                  src={customizationData.our_story_image_url}
                />
              )} */}
              <Divider />
              <Title level={5} className="theme-red mb-1">
                Featured Menu Items
              </Title>
              <Form.Item name="our_story_featured_menu">
                <CustomSelect
                  label="Menu"
                  placeholder="Select menu here"
                  options={menus}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "name" }}
                />
              </Form.Item>
              <Form.Item name="our_story_featured_menu_ids">
                <CustomSelect
                  label="Menu Item"
                  placeholder="Select menu item here"
                  mode="multiple"
                  options={menuItems}
                  style={{ width: "100%" }}
                  fieldNames={{ value: "id", label: "name" }}
                  showSearch
                  // filterOption={(input, option) =>
                  //   (option?.label ?? "")
                  //     .toLowerCase()
                  //     .includes(input.toLowerCase())
                  // }
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-center mt-2">
            <Button
              type="primary"
              className="custom-btn"
              // disabled={isSaving}
              onClick={() => saveCustomizationData()}
            >
              Save
            </Button>
          </div>
        </div>
      </Form>
      </Col>
      <Col xs={24} lg={12}>
        <StoryTemplate
          data={customizationData}
          formFieldsdata={formFieldsdata}
          menuItems={menuItems}
        />
      </Col>
    </Row>
  );
}
